import { projectPath } from "@/routes/app-navigation";

/**
 * Tab-scoped marker for the first-run walkthrough. Connecting an account leaves the app for the
 * platform's OAuth page and comes back to Settings → Channels; this lets it resume the walkthrough.
 */
const KEY = "gridcast:welcome-project";

export const welcomePath = (projectId: string) => `${projectPath(projectId, "overview")}?welcome=1`;

export function markWelcome(projectId: string) {
	sessionStorage.setItem(KEY, projectId);
}

export function clearWelcome() {
	sessionStorage.removeItem(KEY);
}

export const isWelcoming = (projectId: string) => sessionStorage.getItem(KEY) === projectId;
